import { CartSummary, CartSummaryProps } from './CartSummary';
import { connectCartSummary, ConnectedProps } from './connectCartSummary';

export type ConnectedCartSummaryProps = Omit<
    CartSummaryProps,
    keyof ConnectedProps
>;
export const ConnectedCartSummary = connectCartSummary(CartSummary);
